import { motion } from "framer-motion";
import SidebarLayout from "@/components/layout/SidebarLayout";
import PrivateImageLibrary from "@/components/content-generator/private-image-library/PrivateImageLibrary";
import UniversalMultiselectSidebar from "@/components/content-generator/editor/sidebar/UniversalMultiselectSidebar";
import { useBulkImageImport } from "@/hooks/content-generator/useBulkImageImport";

interface WorkbookImagesTabProps {
  pageId: string;
  coverImage?: string;
  onCoverImageChange: (url: string | undefined) => void;
  isUploadModalOpen?: boolean;
  onCloseUploadModal?: () => void;
  onCreateImage?: () => void;
  autoOpenImageId?: string | null; // NEW: Auto-open specific image
  onAutoOpenComplete?: () => void; // NEW: Callback when auto-open is complete
}

export const WorkbookImagesTab = ({ 
  pageId, 
  coverImage, 
  onCoverImageChange, 
  isUploadModalOpen = false, 
  onCloseUploadModal,
  onCreateImage,
  autoOpenImageId, // NEW: Destructure auto-open props
  onAutoOpenComplete
}: WorkbookImagesTabProps) => {
  // Bulk import functionality
  const bulkImportMutation = useBulkImageImport(pageId);

  const handleBulkImport = async (selectedImageIds: string[]) => {
    await bulkImportMutation.mutateAsync(selectedImageIds);
  };

  return (
    <SidebarLayout sidebar={
      <UniversalMultiselectSidebar 
        pageId={pageId} 
        contentType="images"
        onBulkImport={handleBulkImport}
      />
    }>
      {/* Private Image Library Section */}
      <PrivateImageLibrary 
        workbookId={pageId} 
        isUploadModalOpen={isUploadModalOpen}
        onCloseUploadModal={onCloseUploadModal}
        onCreateImage={onCreateImage}
        autoOpenImageId={autoOpenImageId} // NEW: Pass through auto-open image ID
        onAutoOpenComplete={onAutoOpenComplete} // NEW: Pass through completion callback
      />
    </SidebarLayout>
  );
}; 